<li
  class="list-group-item hs-list-item-header list-group-item-primary d-flex justify-content-between align-items-center mb-1"
  (click)="symbolizerVisible = !symbolizerVisible;" [attr.data-test]="getSymbolizerName(symbolizer)">
  <div>
    <button type="button" style="border: none; background-color: transparent; cursor: move">
      <i class="icon-move text-secondary"></i>
    </button>
    <span>{{getSymbolizerName(symbolizer) | translateHs }}&nbsp;</span><!-- TODO: Remove function call from template -->
  </div>
  <div>
    <span class="glyphicon me-2" [ngClass]="symbolizerVisible ? 'icon-chevron-right' : 'icon-chevron-down'"></span>
    <button class="btn btn-danger btn-sm" (click)="removeSymbolizer(symbolizer)" data-toggle="tooltip"
      [title]="'STYLER.removeSymbolizer' | translateHs  ">
      <i class="icon-trash"></i>
    </button>
  </div>
</li>

<ng-container *ngIf="symbolizerVisible">
  <hs-symbolizer [symbolizer]="symbolizer" (changes)="emitChange()" (mousedown)="$event.stopPropagation()">
  </hs-symbolizer>
</ng-container>